import { getListOfPositions } from "@/api";
import {
  getPositions,
  updatePositions,
} from "@components/helper/localStorageHelper";
export default {
  namespaced: true,
  state: {
    positions: [],
    activePositionsCount: 0,
    totalPositionsCount: 0,
    activeAssignmentsCount: 0,
  },
  mutations: {
    setPositions(state, positions) {
      state.positions = positions;
      const activePositions = positions.filter(
        (el) => el.status == "active"
      ).length;
      state.activePositionsCount = activePositions;
    },
    setActivePositionsCount(state, count) {
      state.activePositionsCount = count;
    },
    setTotalPositionsCount(state, count) {
      state.totalPositionsCount = count;
    },
  },
  actions: {
    updateActivePositionsCount({ commit }, count) {
      commit("setActivePositionsCount", count);
    },
    async loadPositions({ state, commit }) {
      try {
        let positionsList = getPositions();
        commit("setPositions", positionsList);
        const accountId = JSON.parse(localStorage.getItem("currentAccountID"));
        await getListOfPositions(accountId, 1, 500)
          .then((response) => {
            if (response.data && response.data.count) {
              state.totalPositionsCount = response.data.count;
            }
            if (response.data && response.data.results) {
              const results = response.data.results.map((position) => {
                // Check if code_str is null or does not exist
                if (!position?.code_str) {
                  position.code_str = `#${position.code} - ${position.name}`;
                }
                return {
                  ...position,
                };
              });
              updatePositions(results);
              commit("setPositions", results);
            }
          })
          .catch((error) => {
            console.error("error fetching employees: ", error);
          });
      } catch (e) {
        console.log("error fetching employees: ", e);
      }
    },
  },
  getters: {
    positions: (state) => state.positions,
    activePositionsCount: (state) => state.activePositionsCount,
    totalPositionsCount: (state) => state.totalPositionsCount,
    getAttachedRolesFromPositionId:
      (state, getters, rootState) => (positionId) => {
        if (!positionId) return [];
        return rootState.readinessCatalogsStore.roles
          .filter((role) => {
            return role.attachments.some(
              (attachment) =>
                attachment.type === "position" && attachment.id === positionId
            );
          })
          .map((role) => {
            if (!role?.code_str) {
              role.code_str = `#${role.code} - ${role.name}`;
            }
            return {
              ...role,
              parentId: -1,
            };
          });
      },
    getAttachedRolesAndResponsibilitiesFromPositionId:
      (state, getters, rootState) => (positionId) => {
        if (!positionId) return [];
        const rolesForPosition = rootState.readinessCatalogsStore.roles
          .filter((role) => {
            return role.attachments.some(
              (attachment) =>
                attachment.type === "position" && attachment.id === positionId
            );
          })
          .map((role) => {
            if (!role?.code_str) {
              role.code_str = `#${role.code} - ${role.name}`;
            }
            return {
              ...role,
              type: "role",
              parentId: -1,
            };
          });
        const responsibilitiesForPosition =
          rootState.readinessCatalogsStore.responsibilities
            .filter((responsibility) => {
              return responsibility.attached_roles.some((attachment) =>
                rolesForPosition.some((role) => role.id === attachment.id)
              );
            })
            .map((responsibility) => {
              const attachedRole = responsibility.attached_roles.find(
                (attachment) =>
                  rolesForPosition.some((role) => role.id === attachment.id)
              );
              if (!responsibility?.code_str) {
                responsibility.code_str = `#${responsibility.code} - ${responsibility.name}`;
              }
              return {
                ...responsibility,
                type: "responsibility",
                parentId: attachedRole ? attachedRole.id : -1,
              };
            });

        return [...rolesForPosition, ...responsibilitiesForPosition];
      },
  },
};
